import React from "react";

// A section wrapper that reveals children on scroll with a stagger delay.
import { useReveal } from "../hooks/useReveal";

export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div" }) => {
  const { ref, visible } = useReveal();
  return (
    <Tag
      ref={ref}
      className={`rq-reveal ${visible ? "rq-in" : ""} ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
